import axios from 'axios';

const csrfToken = document.head.querySelector('meta[name="csrf-token"]');
if (!csrfToken) throw new Error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");

const apiToken = document.head.querySelector('meta[name="api-token"]');
if (!apiToken) throw new Error("API token not found");

export const getHeaders = () => ({
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
	'X-CSRF-TOKEN': csrfToken.content,
	'Authorization': `Bearer ${apiToken.content}`
})

const api = axios.create({
	headers: getHeaders()
});

export default api;
